import React, { useState, useEffect, useContext } from "react";
import { SB3RuleContext } from "../../Components/Rules/SB3RuleContext";
import Table from "../../Components/Rules/RulesTable";
import useTable from "Components/Common/Table/useTable";
import { toast } from "react-toastify";
import RulesDialog from "./RulesDialog";
import NoDataMessage from "../../Components/NoDataMessage";
import { CREATE, EMPTY_RULES } from "../../ISRConstants";
import { deleteRule, updateRule } from "../../service";

type RulesComponentProps = {
  projectId: string | null | undefined
  id: string;
};

const RulesComponent = (props: React.PropsWithChildren<RulesComponentProps>) => {
  const { getRules, showRulesMenu, toggleMenu, } = useContext(SB3RuleContext)

  const handleUpdateRule = async (e: any, data: any) => {
    try {
      const body: any = { ...data }
      body.is_disabled = !body.is_disabled
      const res = await updateRule(body)
      if (res?.data?.done) {
        toast.success("Rule updated succesfully")
        fetchTableData()
      }
    } catch (error) {
      toast.error("Rule update unsuccesfull")
    }
  }

  const RULES_HEADERS = [
    { label: "Name", map: "name", options: { copy: true, isLink: true } },
    { label: "Rule Type", map: "rule_type", options: { sort: true } },
    { label: "Description", map: "description", options: { sort: false } },
    {
      label: "Enable/Disable", map: "is_disabled", options: {
        sort: false, type: "switch", handleSwitch: handleUpdateRule
      }
    },
    { label: "DELETE", map: "delete", options: { sort: false, index: true } },
  ];

  const [recordPerPage, setRecordPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const { headers, data, sort, setData, handleSortByColumn } =
    useTable({ table_headers: RULES_HEADERS });


  const fetchTableData = async () => {
    try {
      setLoading(true);
      if (props?.projectId) {
        let res = await getRules(props?.projectId)
        if (res?.data?.data)
          setData(res?.data?.data);

      }
    } catch (error) {
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  };

  const handleRecordPerPageChange = (perPage: number) => {
    setRecordPerPage(perPage);
    setPage(0);
  };
  const handleEdit = (index: number) => {
    const selectedIndex = (page - 1) * recordPerPage + index
    const cat: any = data[selectedIndex];
    toggleMenu(cat?.id)
  };

  const handleDelete = async (index: number) => {
    const selectedIndex = (page - 1) * recordPerPage + index
    const cat: any = data[selectedIndex];
    const res = await deleteRule(cat?.id)
    if (res) toast.success("Deleted successfully");
    else toast.warning("Delete Unsuccessful")
    fetchTableData()
  }

  useEffect(() => { fetchTableData() }, [showRulesMenu])

  return (
    <div id={props.id} className="tw-w-[100%] tw-mt-2">
      <Table
        headers={headers}
        recordPerPage={recordPerPage}
        setRecordPerPage={handleRecordPerPageChange}
        handlePageChange={setPage}
        data={data}
        loading={loading}
        handleSortByColumn={handleSortByColumn}
        sort={sort}
        page={page}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        NoDataComponent={() =>

          <NoDataMessage id={'create-rules'} buttonText={CREATE} message={EMPTY_RULES} buttonAction={() => { toggleMenu() }} />

        }
        createMethod={() => { toggleMenu() }}
      />
      {
        showRulesMenu && <RulesDialog projectId={props.projectId} />
      }
    </div>
  );
};

export default RulesComponent;
